import { db, firebase } from '@/firebase'
export default{
    saveInfo(key, dataSafe){
        console.log(key, dataSafe);
      
        db.collection(key).add(dataSafe).then(function(docRef) {
            console.log(docRef);
            //user.id = docRef.id
            //loadData(user);
        }).catch(error => {
            console.log(error);
        });
    },
    async Totalfinalizados(key){
        return await db.collection(key).get().then(querySnapshot => querySnapshot.docs.length );
    },
    setUser(){
        firebase.auth().signInAnonymously().catch(function(error) {});
    },
    getUser(){
        firebase.auth().onAuthStateChanged(function(user) {
            console.log(user);
        });
    },
}